export default "__VITE_PUBLIC_ASSET__73881836__"